import type { AgentToolOption } from './api'

import { cn } from '@/lib/cn'

export function ToolSourceMark({ source }: { source: AgentToolOption['source'] }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex h-6 min-w-8 shrink-0 items-center justify-center rounded px-1.5 text-[10px] font-bold tracking-wide',
        source === 'mcp'
          ? 'bg-[rgba(25,91,255,0.1)] text-[var(--color-primary)]'
          : 'bg-[rgba(25,91,255,0.06)] text-[#65718a]',
      )}
    >
      {source === 'mcp' ? 'MCP' : 'AI'}
    </span>
  )
}
